"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlaceholderSize = void 0;
var _constants = require("../constants");
const getPlaceholderSize = ({
  isActive
}) => isActive ? _constants.MEDIA_CAROUSEL_PAGINATION_STEP_ACTIVE_SIZE : _constants.MEDIA_CAROUSEL_PAGINATION_STEP_DEFAULT_SIZE;
exports.getPlaceholderSize = getPlaceholderSize;
//# sourceMappingURL=getPlaceholderSize.js.map